import { Stack, Group, Title, TextInput, Textarea, Alert, Text, Box, TagsInput, Divider } from "@mantine/core";
import { HelpCircle } from "lucide-react";
import { EmailConfig } from "../services/csvSettingsService";

interface EmailConfigurationPanelProps {
  value: EmailConfig;
  onChange: (value: EmailConfig) => void;
}

export function EmailConfigurationPanel({ value, onChange }: EmailConfigurationPanelProps) {
  return (
    <Stack gap="xl">
      <Group justify="space-between">
        <Title order={5}>メール返送設定</Title>
      </Group>

      <Alert icon={<HelpCircle size={16} />} title="メール返送設定について" color="blue" variant="light" radius="md">
        <Text size="xs" mb="sm">
          OCR解析が完了した後、生成されたCSVファイルを自動的にメールで送付するための設定です。取引先ごとに返送先やメールの内容をカスタマイズできます。
        </Text>
        
        <Text size="xs" fw={700} mb={4}>各項目の役割</Text>
        <Box component="ul" style={{ margin: 0, paddingLeft: '1.2rem' }}>
          <Text component="li" size="xs">
            <strong>返送先・CCアドレス:</strong> CSVを受け取りたい担当者のアドレスを指定します。
          </Text>
          <Text component="li" size="xs" mt={4}>
            <strong>テンプレート構成:</strong> 決まった件名や本文で送信することで、受信側のメール整理やフィルタリングを容易にします。
          </Text>
        </Box>
      </Alert>

      {/* 宛先設定セクション */}
      <Stack gap="md" style={{ maxWidth: 800 }}>
        <Title order={6} size="sm">宛先設定</Title>
        <TagsInput
          label="CSV返送先メールアドレス"
          description="Enterキーまたはカンマで追加"
          placeholder="system@example.com"
          value={value.replyTo}
          onChange={(tags) =>
            onChange({
              ...value,
              replyTo: tags,
            })
          }
          clearable
        />

        <TagsInput
          label="CCアドレス"
          description="Enterキーまたはカンマで追加"
          placeholder="manager@example.com"
          value={value.ccAddresses || []}
          onChange={(tags) =>
            onChange({
              ...value,
              ccAddresses: tags,
            })
          }
          clearable
        />
      </Stack>

      <Divider variant="dashed" />

      {/* テンプレート設定セクション */}
      <Stack gap="md" style={{ maxWidth: 800 }}>
        <Title order={6} size="sm">テンプレート設定</Title>
        <TextInput
          label="件名テンプレート"
          placeholder="[IBS-OCR] 発注データ"
          value={value.subjectTemplate || ""}
          onChange={(e) =>
            onChange({
              ...value,
              subjectTemplate: e.currentTarget.value,
            })
          }
        />

        <Textarea
          label="本文テンプレート"
          autosize
          minRows={10}
          placeholder="OCR処理が完了しました。添付のCSVファイルをご確認ください。"
          value={value.bodyTemplate || ""}
          onChange={(e) =>
            onChange({
              ...value,
              bodyTemplate: e.currentTarget.value,
            })
          }
        />
      </Stack>
    </Stack>
  );
}
